import VisitStopwatch from "./VisitStopwatch";

export default VisitStopwatch;